import React from 'react';
import { useLayout } from '../../../utils/useLayout';
import CustomEmblaCarousel from '../../organisms/CustomEmblaCarousel';

function MobileOnlyCarousel({ children, carouselProps, threshold, useThreshold, ...props }) {
  const { mobile, width } = useLayout();

  if (!useThreshold && mobile) {
    return (
      <CustomEmblaCarousel {...carouselProps} {...props}>
        {({ className }) => <>{children({ className })}</>}
      </CustomEmblaCarousel>
    );
  }

  if (useThreshold && threshold && width) {
    if (threshold > width) {
      return (
        <CustomEmblaCarousel {...carouselProps} {...props}>
          {({ className }) => <>{children({ className })}</>}
        </CustomEmblaCarousel>
      );
    }
  }

  return <>{children({ className: '' })}</>;
}

MobileOnlyCarousel.defaultProps = {
  carouselProps: {},
};

export default MobileOnlyCarousel;
